// Constants for filter components
export const DRAWER_WIDTH = '33.8rem'
export const FALLBACK_COLOR = '#000000'
export const CLEAR_ALL_THRESHOLD = 2
export const DRAWER_TITLE_TEXT = 'FILTER'
export const DRAWER_FOOTER_VIEW_TEXT = 'View'
export const CLEAR_ALL_TEXT = 'Clear All'
export const DRAWER_FOOTER_CLEAR_TEXT = 'Clear'

// Filter keys for telemetry
export const GLOBAL_FILTER_KEY = 'global'
export const COLORS_FILTER_KEY = 'colors-filter'

// Type constants
export const FILTER_TYPES = {
  CARD: 'card',
  CHECKBOX: 'checkbox',
} as const

// Sort drawer titles [Mobile]
export const SORT_DRAWER_TITLE = 'SORT BY'

// Sort button text [Desktop]
export const SORT_BUTTON_TEXT = 'Sort By'
